module.exports = __webpack_public_path__ + "static/img/equipmentIntroduction.4d1c906.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/equipment/zh/equipmentIntroduction.png
// module id = rw3E
// module chunks = 1